/* Pop-up de campanha com cronometro (ticket a31dd66f) */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function init(root) {
    if (!root || root.dataset.oppReady) return;
    root.dataset.oppReady = '1';

    var end = new Date(root.dataset.end).getTime();
    if (isNaN(end) || Date.now() >= end) { root.remove(); return; }

    var key = root.dataset.key || 'origgo-promo';
    var dialog = root.querySelector('.origgo-promo-popup__dialog');
    var elH = root.querySelector('[data-opp-h]');
    var elM = root.querySelector('[data-opp-m]');
    var elS = root.querySelector('[data-opp-s]');
    var interval = null;
    var lastFocus = null;
    var isOpen = false;

    function remember() {
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
    }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        close();
        root.remove();
        return;
      }
      var t = Math.floor(diff / 1000);
      if (elH) elH.textContent = pad(Math.floor(t / 3600));
      if (elM) elM.textContent = pad(Math.floor((t % 3600) / 60));
      if (elS) elS.textContent = pad(t % 60);
    }

    function focusables() {
      return Array.prototype.slice.call(dialog.querySelectorAll('a[href], button:not([disabled])'));
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      tick();
      interval = setInterval(tick, 1000);
      root.hidden = false;
      document.documentElement.classList.add('opp-lock');
      requestAnimationFrame(function () {
        root.classList.add('is-open');
        try { dialog.focus({ preventScroll: true }); } catch (e) { dialog.focus(); }
      });
      document.addEventListener('keydown', onKey);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      remember();
      clearInterval(interval);
      root.classList.remove('is-open');
      document.documentElement.classList.remove('opp-lock');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { root.hidden = true; }, 300);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }

    root._oppOpen = open;
    root._oppClose = close;

    Array.prototype.forEach.call(root.querySelectorAll('[data-opp-close]'), function (el) {
      el.addEventListener('click', close);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-opp-cta]'), function (el) {
      el.addEventListener('click', remember);
    });

    var copyBtn = root.querySelector('[data-opp-copy]');
    if (copyBtn) {
      var copyLabel = copyBtn.textContent;
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-opp-copy');
        var done = function () {
          copyBtn.textContent = copyBtn.getAttribute('data-opp-copied') || copyLabel;
          setTimeout(function () { copyBtn.textContent = copyLabel; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          try {
            var tmp = document.createElement('textarea');
            tmp.value = code;
            tmp.setAttribute('readonly', '');
            tmp.style.position = 'absolute';
            tmp.style.left = '-9999px';
            document.body.appendChild(tmp);
            tmp.select();
            document.execCommand('copy');
            document.body.removeChild(tmp);
          } catch (e) {}
          done();
        }
      });
    }

    if (window.Shopify && window.Shopify.designMode) return;

    var seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; } catch (e) {}
    if (seen) return;

    var delay = parseInt(root.dataset.delay, 10);
    if (isNaN(delay) || delay < 0) delay = 0;
    setTimeout(open, delay * 1000);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-origgo-promo-popup]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-origgo-promo-popup]'));
  });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector('[data-origgo-promo-popup]');
    if (root && root._oppOpen) root._oppOpen();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var root = e.target.querySelector('[data-origgo-promo-popup]');
    if (root && root._oppClose) root._oppClose();
  });
})();
